export const languages = ["English", "Ukrainian", "Polish", "German"];
